import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/atoms';
import { ApiError } from '@/services/api';
import { authApi } from '@/services/auth';
import { useAuth } from '@/store/useAuth';
import { useBrand } from '@/store/useBrand';

import styles from './Login.module.css';

export function Login() {
  const navigate = useNavigate();
  const setAuth = useAuth((s) => s.setAuth);
  const brand = useBrand((s) => s.brand);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await authApi.login(username.trim(), password);
      setAuth(res.access_token, res.username, res.role, res.must_change_password);
      navigate(res.must_change_password ? '/trocar-senha' : '/', { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 429) {
        setError('Demasiadas tentativas. Aguarde um minuto e tente de novo.');
      } else {
        setError('Credenciais inválidas.');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.root}>
      <form className={styles.card} onSubmit={handleSubmit}>
        <div className={styles.brand}>
          {brand.logo_url ? (
            <img className={styles.logo} src={brand.logo_url} alt={brand.name} />
          ) : (
            <>
              <span className={styles.brandMark}>{brand.name}</span>
              {brand.sub && <span className={styles.brandSub}>{brand.sub}</span>}
            </>
          )}
        </div>
        <p className={styles.tagline}>{brand.tagline}</p>

        <label className={styles.field}>
          <span>Utilizador</span>
          <input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
        </label>

        <label className={styles.field}>
          <span>Senha</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>

        {error && <p className={styles.error}>{error}</p>}

        <Button type="submit" loading={loading} className={styles.submit}>
          Entrar
        </Button>
      </form>
    </div>
  );
}
